import ApiService from "@Src/services/ApiService";
import { MINDMAP_API_ROUTES } from "./MindMap.api.constant";

export async function getMindMapList(params?: any) {
    return await ApiService.fetchData({
        url: MINDMAP_API_ROUTES.GET_MINDMAP_LIST,
        method: 'get',
        params,
    });
}

export async function postNoteAndBookmark(payload:any){

    return await ApiService.fetchData({
        url: MINDMAP_API_ROUTES.POST_NOTE_AND_BOOKMARK,
        method: "post",
        data: payload
    });
}
